module.exports = __webpack_public_path__ + "img/automation4.bfa61129.png";